import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { authType } from '../../types';

const PrivateRoute = ({ children, auth }) => {
  const location = useLocation();

  // triedAuth checks to make sure authentication is at least attempted before redirecting you
  // it's for when you hard refresh a page
  if (!auth.triedAuth) {
    return null;
  }

  if (auth.authenticated) {
    return children;
  }

  return <Navigate to="/login" state={{ from: location }} replace />;
};

PrivateRoute.propTypes = {
  auth: authType.isRequired,
  children: PropTypes.node.isRequired
};

const mapStateToProps = ({ auth }) => {
  return { auth };
};

export default connect(mapStateToProps)(PrivateRoute);
